export const tryConvertToJsonString = (obj: any) => {
  try {

    if (typeof obj === 'string') {
      return obj;
    }

    return JSON.stringify(obj, Object.getOwnPropertyNames(obj));
  } catch (err) {
    return `Failed to tryConvertToJsonString object!`;
  }
};
